<template>
  <Dialog
    v-model:visible="visible"
    modal
    header="New WorkSpace"
    :style="{ width: '25rem' }"
  >
    <div class="flex items-center gap-4 mb-8">
      <div class="grid grid-cols-1 w-full">
        <div class="grid grid-cols-1 w-full">
          <div class="w-full">
            Name
          </div>
          <div class="w-full">
            <InputText
              v-model="workSpaceName"
              fluid
              class="w-full"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end gap-2">
      <Button
        type="button"
        label="Cancel"
        severity="secondary"
        @click="visible = false"
      />
      <Button
        :loading="isLoading"
        type="button"
        label="Create"
        @click="create()"
      />
    </div>
  </Dialog>
</template>

<script setup lang="ts">
const visible = defineModel('visible')
const props = defineProps(['userName'])
const emit = defineEmits(['init'])
const workSpaceName = ref('')
const isLoading = ref(false)

const { createWorkSpace } = useWorkSpace()
const create = async () => {
  isLoading.value = true
  await createWorkSpace({
    name: workSpaceName.value,
    userFullName: props.userName,
  })
  visible.value = false
  isLoading.value = false
  emit('init')
}
</script>
